import { render, staticRenderFns } from "./SettingsImportConfig.vue?vue&type=template&id=22ccf650&scoped=true"
import script from "./SettingsImportConfig.vue?vue&type=script&lang=js"
export * from "./SettingsImportConfig.vue?vue&type=script&lang=js"
import style0 from "./SettingsImportConfig.vue?vue&type=style&index=0&id=22ccf650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccf650",
  null
  
)

export default component.exports